/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import DeleteButton from "main/components/DeleteButton/DeleteButton";
import { getErrorMsg, showToast } from "main/shared/helpers";
import React, { Suspense, useEffect, useState } from "react";

import { Spinner } from "react-bootstrap";
import ScrollBar from "react-perfect-scrollbar";
import { useParams } from "react-router-dom";
import {
  deleteObservationImage,
  getInspectionRooms,
  getObservationComments,
  getObservationImages,
  getObservationTests,
  updateObservationImage,
  orderObservationImages,
  orderRooms,
} from "../../../../../services/ObservationService";
import ImageBox from "../../../../components/ImageBox/ImageBox";
import Paginator from "../../../../components/Paginator/Paginator";
import AddCaption, { AddCaptionModal } from "./AddCaption";
import CommentRow from "./CommentRow";
import EmptyListIndicator from "./EmptyListIndicator";
import ObservationSubList from "./ObservationSubList";
import TestRow from "./TestRow";
import ImageViewerModal from "../../../../components/ImageViewerModal/ImageViewerModal";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  rectSortingStrategy,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { debounce } from "lodash";
import CustomTooltip from "main/components/Tooltip/Tooltip";

import logger from "main/shared/logger";
const AddObservationModal = React.lazy(() => import("./AddObservationModal"));
const AddRoomModal = React.lazy(() => import("./AddRoomModal"));
const AddTestModal = React.lazy(() => import("./AddTestModal"));
const AddPhotoModal = React.lazy(() => import("./AddPhotoModal"));
const AddCommentsModal = React.lazy(() => import("./AddCommentsModal"));

// Add SortablePhoto component for drag-and-drop
function SortablePhoto({
  photo,
  i,
  handleDeleteObservationPhoto,
  handlePhotoClick,
  setEditCaptionModal,
  setCaptionData,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: photo.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    userSelect: "none",
    background: "transparent",
    cursor: "grab",
    borderRadius: "8px",
    position: "relative",
    marginRight: "12px",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div
        style={{
          position: "absolute",
          right: "10px",
          top: "7px",
          zIndex: 10,
        }}
      >
        <DeleteButton
          deleteFunction={handleDeleteObservationPhoto(photo.id)}
          message="Are you sure you want to delete this photo?"
        />
      </div>
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handlePhotoClick(photo, i);
        }}
        style={{ cursor: "pointer" }}
      >
        <ImageBox
          src={photo.url}
          link={false}
          onClick={() => handlePhotoClick(photo, i)}
          style={{
            border: "none",
            height: "145px",
            width: "145px",
            boxShadow: "0 0 15px 1px rgba(132,133,122,0.5)",
            transform: `rotate(${photo.rotation || 0}deg)`,
          }}
          imgStyle={{
            height: "140px",
            width: "145px",
          }}
        />
      </div>
      <AddCaption
        caption={photo.caption}
        edit={() => {
          setEditCaptionModal(true);
          setCaptionData({
            id: photo.id,
            caption: photo.caption,
          });
        }}
      />
    </div>
  );
}

// SortableRoom component for drag-and-drop rooms
function SortableRoom({
  room,
  i,
  selectedRoomId,
  setSelectedRoom,
  setSelectedRoomId,
  setSelectedObservation,
  setShowAddObservationModal,
  setSelectedObservationId,
  refreshSubList,
  setRefreshRoomList,
  setEditObservation,
  onEditRoom,
  isAnyRoomDragging,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: room.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: 1,
    height: "auto",
    minHeight: "auto",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <ObservationSubList
        name={room.room_name}
        key={room.room_name + "-" + i}
        selectedRoomId={selectedRoomId}
        onOpen={() => {
          setSelectedRoom(room.room_name);
          setSelectedRoomId(room.id);
        }}
        setSelectedObservation={setSelectedObservation}
        openAddObservationModal={() => setShowAddObservationModal(true)}
        roomId={room.id}
        setSelectedObservationId={setSelectedObservationId}
        refreshSubList={refreshSubList}
        refreshRoomList={() => setRefreshRoomList((s) => !s)}
        setEditObservation={setEditObservation}
        onEditRoom={() => onEditRoom(room)}
        dragListeners={listeners}
        isDragging={isDragging || isAnyRoomDragging}
      />
    </div>
  );
}

export default function Observation() {
  const { insp_id } = useParams();
  const [loader, setLoader] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [editRoom, setEditRoom] = useState({});
  const [activePage, setActivePage] = useState(1);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(0);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [selectedObservation, setSelectedObservation] = useState("");
  const [selectedObservationId, setSelectedObservationId] = useState(null);
  const [page, setpage] = useState(1);
  const [showAddObservationModal, setShowAddObservationModal] = useState(false);
  const [showAddRoomModal, setShowAddRoomModal] = useState(false);
  const [showAddTestModal, setShowAddTestModal] = useState(false);
  const [showAddPhotoModal, setShowAddPhotoModal] = useState(false);
  const [showAddCommentsModal, setShowAddCommentsModal] = useState(false);
  const [editObservation, setEditObservation] = useState({});

  const [testsData, setTestsData] = useState([]);
  const [testPage, setTestPage] = useState(1);
  const [activePageTest, setActivePageTest] = useState(1);
  const [itemsCountPerPageTest, setItemsCountPerPageTest] = useState(0);
  const [totalItemsCountTest, setTotalItemsCountTest] = useState(0);
  const [testLoader, setTestLoader] = useState(false);

  const [commentsData, setCommentsData] = useState([]);
  const [commentPage, setCommentPage] = useState(1);
  const [activePageComment, setActivePageComment] = useState(1);
  const [itemsCountPerPageComment, setItemsCountPerPageComment] = useState(0);
  const [totalItemsCountComment, setTotalItemsCountComment] = useState(0);
  const [commentLoader, setCommentLoader] = useState(false);

  const [photos, setPhotos] = useState([]);
  const [photosPage] = useState(1);
  const [photosLoader, setPhotosLoader] = useState(false);
  const [refreshSubList, setRefreshSubList] = useState(true);
  const [refreshRoomList, setRefreshRoomList] = useState(true);
  const [refreshTestList, setRefreshTestList] = useState(true);
  const [refreshCommentList, setRefreshCommentList] = useState(true);
  const [refreshPhotoList, setRefreshPhotoList] = useState(true);

  const [editCaptionModal, setEditCaptionModal] = useState(false);
  const [captionData, setCaptionData] = useState({ id: null, caption: "" });

  const [noData, setNoData] = useState(false);

  const [showImageViewer, setShowImageViewer] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const [isAnyRoomDragging, setIsAnyRoomDragging] = useState(false);

  // DnD Kit sensors and activeId for drag-and-drop
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  // Debounced API call to save image order
  const debouncedOrderImages = React.useRef(
    debounce((orderedPhotos, inspectionId) => {
      const image_id = orderedPhotos.map((p) => p.id);
      const order_sequenece = orderedPhotos.map((_, idx) => idx + 1);
      const payload = {
        image_id,
        order_sequence: order_sequenece,
        inspection_id: inspectionId,
      };
      orderObservationImages(payload)
        .then(() => {
          showToast("Photo order saved successfully", true);
        })
        .catch((err) => {
          showToast(getErrorMsg(err) || "Error saving photo order");
        });
    }, 1000)
  ).current;

  // Debounced API call to save room order
  const debouncedOrderRooms = React.useRef(
    debounce((orderedRooms, inspectionId) => {
      const room_id = orderedRooms.map((r) => r.id);
      const order_sequence = orderedRooms.map((_, idx) => idx + 1);
      const payload = {
        inspection_id: inspectionId,
        room_id,
        order_sequence,
      };
      orderRooms(payload)
        .then(() => {
          showToast("Room order saved successfully", true);
        })
        .catch((err) => {
          showToast(getErrorMsg(err) || "Error saving room order");
        });
    }, 1000)
  ).current;

  // Handle drag end for photos
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      const oldIndex = photos.findIndex((p) => p.id === active.id);
      const newIndex = photos.findIndex((p) => p.id === over.id);
      const newPhotos = arrayMove(photos, oldIndex, newIndex);
      setPhotos(newPhotos);
      debouncedOrderImages(newPhotos, insp_id);
    }
  };

  // Handle drag end for rooms
  const handleRoomDragEnd = (event) => {
    const { active, over } = event;
    setIsAnyRoomDragging(false);

    if (active && over && active.id !== over.id) {
      const oldIndex = rooms.findIndex((r) => r.id === active.id);
      const newIndex = rooms.findIndex((r) => r.id === over.id);
      const newRooms = arrayMove(rooms, oldIndex, newIndex);
      setRooms(newRooms);
      debouncedOrderRooms(newRooms, insp_id);
    }
  };

  // Handle drag start for rooms
  const handleRoomDragStart = () => {
    setIsAnyRoomDragging(true);
  };

  useEffect(() => {
    getRooms(page);
  }, [page, refreshRoomList]);

  useEffect(() => {
    if (selectedObservationId) {
      getComments(selectedObservationId, commentPage);
    }
  }, [commentPage, refreshCommentList]);

  useEffect(() => {
    if (selectedObservationId) {
      getTests(selectedObservationId, testPage);
    }
  }, [testPage, refreshTestList]);

  useEffect(() => {
    if (selectedObservationId) {
      getPhotos(selectedObservationId, photosPage);
    }
  }, [photosPage, refreshPhotoList]);

  useEffect(() => {
    if (selectedObservationId) {
      getDetails(selectedObservationId);
    }
  }, [selectedObservationId]);

  const getRooms = (page) => {
    setLoader(true);
    getInspectionRooms(insp_id, page)
      .then((res) => {
        setRooms(res.data.data);
        if (res.data.data.length > 0) {
          setSelectedRoom(res.data.data[0].room_name);
          setSelectedRoomId(res.data.data[0].id);
          setActivePage(res.data.current_page);
          setItemsCountPerPage(res.data.per_page);
          setTotalItemsCount(res.data.total);
          setNoData(false);
        } else {
          setNoData(true);
        }
      })
      .catch(() => {})
      .finally(() => setLoader(false));
  };

  const getDetails = (id) => {
    if (id) {
      getTests(id, testPage);
      getComments(id, commentPage);
      getPhotos(id, photosPage);
    }
  };

  const getTests = (id, page) => {
    setTestLoader(true);
    getObservationTests(id, page)
      .then((res) => {
        setTestsData(res.data.data);
        setItemsCountPerPageTest(res.data.per_page);
        setTotalItemsCountTest(res.data.total);
        setActivePageTest(res.data.currrent);
      })
      .catch(() => {})
      .finally(() => setTestLoader(false));
  };

  const getComments = (id, page) => {
    setCommentLoader(true);
    getObservationComments(id, page)
      .then((res) => {
        setCommentsData(res.data.data);
        setItemsCountPerPageComment(res.data.per_page);
        setTotalItemsCountComment(res.data.total);
        setActivePageComment(res.data.currrent);
      })
      .catch(() => {})
      .finally(() => setCommentLoader(false));
  };

  const getPhotos = (id, page) => {
    setPhotosLoader(true);
    getObservationImages(id, page)
      .then((res) => {
        setPhotos(res.data.data);
      })
      .catch(() => {})
      .finally(() => setPhotosLoader(false));
  };

  const handleDeleteObservationPhoto = (id) => {
    return (setLoading) => {
      setLoading(true);
      deleteObservationImage(id)
        .then(() => {
          showToast("Photo deleted successfully", true);
          setLoading(false);
          setRefreshPhotoList((s) => !s);
        })
        .catch((err) => {
          showToast(getErrorMsg(err) || "Error deleting photo");
          setLoading(false);
        });
    };
  };

  const onEditRoom = (room) => {
    setEditRoom(room);
    setShowAddRoomModal(true);
  };

  const handlePhotoClick = (photo, i) => {
    setSelectedPhoto({ photo: photo, photoIndex: i });
    setShowImageViewer(true);
  };

  const handleRotatePhoto = async (photo, rotation) => {
    try {
      await updateObservationImage(photo.id, { ...photo, rotation: rotation });
      // Refresh photo list to get updated rotation from server
      setRefreshPhotoList((s) => !s);
    } catch (error) {
      logger.error("Error rotating image:", error);
      showToast(getErrorMsg(error) || "Error rotating image");
    }
  };

  return (
    <React.Fragment>
      <div className="tab-child">
        <div className="leftside" style={{ padding: "15px 5px 5px 5px" }}>
          <div className="leftside-header d-flex align-items-center justify-content-between">
            <h5 className="mainheading">Rooms</h5>
            <button
              className="btn btn-primary ml-auto"
              onClick={() => setShowAddRoomModal(true)}
            >
              Add Room <AddIcon />
            </button>
          </div>
          <ScrollBar style={{ height: "auto" }}>
            <ul
              className={loader ? "ul-style list-spinner" : "ul-style"}
              style={{
                height: "calc(100vh - 250px)",
                padding: "0px 5px 0px 5px",
              }}
            >
              {loader ? (
                <Spinner animation="border" variant="success" />
              ) : rooms.length > 0 ? (
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragStart={handleRoomDragStart}
                  onDragEnd={handleRoomDragEnd}
                >
                  <SortableContext
                    items={rooms.map((r) => r.id)}
                    strategy={verticalListSortingStrategy}
                  >
                    {rooms.map((item, i) => (
                      <SortableRoom
                        key={item.id}
                        room={item}
                        i={i}
                        selectedRoomId={selectedRoomId}
                        setSelectedRoom={setSelectedRoom}
                        setSelectedRoomId={setSelectedRoomId}
                        setSelectedObservation={setSelectedObservation}
                        setShowAddObservationModal={setShowAddObservationModal}
                        setSelectedObservationId={setSelectedObservationId}
                        refreshSubList={refreshSubList}
                        setRefreshRoomList={setRefreshRoomList}
                        setEditObservation={setEditObservation}
                        onEditRoom={onEditRoom}
                        isAnyRoomDragging={isAnyRoomDragging}
                      />
                    ))}
                  </SortableContext>
                </DndContext>
              ) : null}
              {noData && (
                <li className="liststyle listActive">No rooms added!</li>
              )}
            </ul>
          </ScrollBar>
          <Paginator
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={totalItemsCount}
            onChange={(page) => setpage(page)}
          />
        </div>
        <ScrollBar
          className="round-top"
          style={{
            height: "calc(100vh - 140px)",
            overflowY: "auto",
            width: "100%",
            background: "#e7ece8",
          }}
        >
          <div className="rightside" style={{ width: "100%" }}>
            <div className="rightsideinner">
              {!noData && selectedObservationId && (
                <React.Fragment>
                  <div className="observation-details-section">
                    <span className="text-light20 protocol-top-text">
                      {`${selectedRoom} - ${selectedObservation}`}
                    </span>
                    <hr className="bold-hr" style={{ opacity: 1 }} />
                  </div>
                  <div className="observation-details-section">
                    <div className="d-flex align-items-center justify-content-between">
                      <span
                        className="text-light20 fw-bolder"
                        style={{ fontSize: "18px" }}
                      >
                        Tests
                      </span>
                      {testsData.length === 5 ? (
                        <CustomTooltip text="Maximum 5 tests can be created">
                          <span className="ml-auto">
                            <button
                              className="btn btn-primary"
                              onClick={() => setShowAddTestModal(true)}
                              disabled={true}
                              style={{
                                cursor: "not-allowed !important",
                                pointerEvents: "auto",
                              }}
                            >
                              Add Test <AddIcon />
                            </button>
                          </span>
                        </CustomTooltip>
                      ) : (
                        <span className="ml-auto">
                          <button
                            className="btn btn-primary"
                            onClick={() => setShowAddTestModal(true)}
                            disabled={testsData.length === 5}
                          >
                            Add Test <AddIcon />
                          </button>
                        </span>
                      )}
                    </div>
                    <ScrollBar className="mt-2">
                      <div
                        className={
                          testLoader ? "observation-detail-list-spinner" : ""
                        }
                        style={{ maxHeight: "250px", marginRight: "15px" }}
                      >
                        {testLoader ? (
                          <Spinner animation="border" variant="success" />
                        ) : testsData.length !== 0 ? (
                          <table
                            id="test_table"
                            className="table td-middle pe-3 pb-3 spacing"
                          >
                            <tbody className="">
                              {testsData.map((test, i) => (
                                <TestRow
                                  test={test}
                                  i={i}
                                  insp_id={insp_id}
                                  key={`test_${i}`}
                                  refresh={() => setRefreshTestList((s) => !s)}
                                />
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <EmptyListIndicator text="No Tests" />
                        )}
                      </div>
                    </ScrollBar>
                    {testsData.length !== 0 && (
                      <Paginator
                        activePage={activePageTest}
                        itemsCountPerPage={itemsCountPerPageTest}
                        totalItemsCount={totalItemsCountTest}
                        onChange={(page) => setTestPage(page)}
                      />
                    )}
                  </div>

                  {/* show comments list start */}
                  <div className="observation-details-section">
                    <div className="d-flex align-items-center justify-content-between">
                      {/* comments heading start */}
                      <span
                        className="text-light20 fw-bolder"
                        style={{ fontSize: "18px" }}
                      >
                        Comments
                      </span>
                      {/* comments heading end */}
                      {/* add comments button start */}

                      {commentsData.length === 12 ? (
                        <CustomTooltip text="Maximum 12 comments can be created">
                          <span className="ml-auto">
                            <button
                              className="btn btn-primary ml-auto"
                              onClick={() => setShowAddCommentsModal(true)}
                              disabled={commentsData.length === 12}
                              style={{
                                cursor: "not-allowed !important",
                                pointerEvents: "auto",
                              }}
                            >
                              Add Comment <AddIcon />
                            </button>
                          </span>
                        </CustomTooltip>
                      ) : (
                        <span className="ml-auto">
                          <button
                            className="btn btn-primary ml-auto"
                            onClick={() => setShowAddCommentsModal(true)}
                            disabled={commentsData.length === 12}
                          >
                            Add Comment <AddIcon />
                          </button>
                        </span>
                      )}
                      {/* add comments button end */}
                    </div>
                    {/* comments list show start */}
                    <ScrollBar
                      className="mt-2"
                      options={{
                        suppressScrollX: true,
                        useBothWheelAxes: false,
                      }}
                    >
                      <div
                        className={
                          commentLoader ? "observation-detail-list-spinner" : ""
                        }
                        style={{ maxHeight: "250px", marginRight: "15px" }}
                      >
                        {commentLoader ? (
                          <Spinner animation="border" variant="success" />
                        ) : commentsData.length !== 0 ? (
                          <table
                            id="comment_table"
                            className="table td-middle pe-3 pb-3 spacing"
                          >
                            <tbody>
                              {commentsData.map((comment, i) => (
                                <CommentRow
                                  key={`comment_${i}`}
                                  comment={comment}
                                  i={i}
                                  setRefreshList={setRefreshCommentList}
                                />
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <EmptyListIndicator text="No Comments" />
                        )}
                      </div>
                    </ScrollBar>
                    {/* comments list show end */}
                    {/* comments pagination start */}
                    {commentsData.length !== 0 && (
                      <Paginator
                        activePage={activePageComment}
                        itemsCountPerPage={itemsCountPerPageComment}
                        totalItemsCount={totalItemsCountComment}
                        onChange={(page) => setCommentPage(page)}
                      />
                    )}
                    {/* comments pagination end */}
                  </div>
                  {/* show comments list end */}

                  <div className="observation-details-section">
                    <div className="d-flex align-items-center justify-content-between">
                      <span
                        className="text-light20 fw-bolder"
                        style={{ fontSize: "18px" }}
                      >
                        Photos
                      </span>

                      {photos.length === 8 ? (
                        <CustomTooltip text="Maximum 8 photos can be uploaded">
                          <span className="ml-auto">
                            <button
                              className="btn btn-primary ml-auto"
                              onClick={() => setShowAddPhotoModal(true)}
                              disabled={true}
                              style={{
                                cursor: "not-allowed !important",
                                pointerEvents: "auto",
                              }}
                            >
                              Add Photo <AddIcon />
                            </button>
                          </span>
                        </CustomTooltip>
                      ) : (
                        <span className="ml-auto">
                          <button
                            className="btn btn-primary ml-auto"
                            onClick={() => setShowAddPhotoModal(true)}
                            disabled={photos.length === 8}
                          >
                            Add Photo <AddIcon />
                          </button>
                        </span>
                      )}
                    </div>
                    <div className="mt-2 overflow-x-auto">
                      <div
                        className={`${
                          photos.length !== 0 ? "d-flex flex-row py-3 pe-3" : ""
                        }${
                          photosLoader ? "observation-detail-list-spinner" : ""
                        }`}
                        style={{ maxHeight: "100%", marginRight: "10px" }}
                      >
                        {photosLoader ? (
                          <Spinner animation="border" variant="success" />
                        ) : photos.length !== 0 ? (
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                          >
                            <SortableContext
                              items={photos.map((p) => p.id)}
                              strategy={rectSortingStrategy}
                            >
                              <div
                                className="d-flex p-3"
                                style={{ maxHeight: "100%" }}
                              >
                                {photos.map((photo, i) => (
                                  <SortablePhoto
                                    key={photo.id}
                                    photo={photo}
                                    i={i}
                                    handleDeleteObservationPhoto={
                                      handleDeleteObservationPhoto
                                    }
                                    handlePhotoClick={handlePhotoClick}
                                    setEditCaptionModal={setEditCaptionModal}
                                    setCaptionData={setCaptionData}
                                  />
                                ))}
                              </div>
                            </SortableContext>
                          </DndContext>
                        ) : (
                          <EmptyListIndicator text="No Photos" />
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </ScrollBar>
      </div>

      <Suspense fallback={null}>
        <AddObservationModal
          show={showAddObservationModal}
          onHide={() => setShowAddObservationModal(false)}
          roomId={selectedRoomId}
          setRefreshSubList={setRefreshSubList}
          editObservation={editObservation}
          setEditObservation={setEditObservation}
        />
      </Suspense>

      <Suspense fallback={null}>
        <AddRoomModal
          inspectionId={insp_id}
          show={showAddRoomModal}
          onHide={() => setShowAddRoomModal(false)}
          setRefreshRoomList={setRefreshRoomList}
          editRoom={editRoom}
          setEditRoom={setEditRoom}
        />
      </Suspense>

      <Suspense fallback={null}>
        <AddTestModal
          setRefreshTestList={setRefreshTestList}
          observationId={selectedObservationId}
          show={showAddTestModal}
          onHide={() => setShowAddTestModal(false)}
        />
      </Suspense>

      <Suspense fallback={null}>
        <AddPhotoModal
          setRefreshList={setRefreshPhotoList}
          observationId={selectedObservationId}
          show={showAddPhotoModal}
          onHide={() => setShowAddPhotoModal(false)}
          photosLength={photos.length}
        />
      </Suspense>
      {/* comments add button start */}
      <Suspense fallback={null}>
        <AddCommentsModal
          show={showAddCommentsModal}
          onHide={() => setShowAddCommentsModal(false)}
          setRefreshList={setRefreshCommentList}
          observationId={selectedObservationId}
          d_coments=""
        />
      </Suspense>

      <AddCaptionModal
        show={editCaptionModal}
        onHide={() => setEditCaptionModal(false)}
        data={captionData}
        refresh={() => setRefreshPhotoList((s) => !s)}
      />
      {/* comments add button end */}

      <ImageViewerModal
        show={showImageViewer}
        onHide={() => setShowImageViewer(false)}
        image={selectedPhoto?.photo}
        photos={photos}
        setSelectedPhoto={(photo) =>
          setSelectedPhoto(
            photo ? { photo, photoIndex: photos.indexOf(photo) } : null
          )
        }
        photoIndex={selectedPhoto ? photos.indexOf(selectedPhoto.photo) : -1}
        onRotate={handleRotatePhoto}
      />
    </React.Fragment>
  );
}
